import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

type FlashBannerMessageWrapperProps = {
  center: boolean
}

function FlashBannerMessageWrapper({
  center,
  children
}: React.PropsWithChildren<FlashBannerMessageWrapperProps>) {
  const classes = classNames(styles.flashContent, {
    [styles.flashContent_center]: center
  })
  return <div className={classes}>{children}</div>
}

export default FlashBannerMessageWrapper
